export const HOST = `/pth/v1/dashboard`;
